export const appResourceTypeMap: Record<string, string> = {
  '52d49c33-2692-441e-b493-98ad76a7973c': 'c1',
  '8fd19abf-94a2-40ea-b3d8-3e617ae3489c': 'c2',
  '3b75c690-cdc5-4bb2-ac81-deb5de4da90c': 'c3',
  '96b50166-322a-45c4-a735-2b28fe208dc1': 'c4',
  '9ebe3dab-3539-4bf2-8511-9afabcfaaf2a': 'h1',
  'd51cec7e-be3b-422c-b4d0-9afa19db0764': 'm1',
  '28c430ac-a860-40f4-ac0c-667fad8d7d2a': 'm2',
  'b2298afd-a314-4fce-90da-784569e5219b': 'm3',
  '97cbbe83-e773-42e5-b4d8-919e3215b8d6': 'm4',
  'd942f69c-2127-4983-be2a-e569cb1012a2': 'm5',
  '474d8d4c-ce53-47af-acfe-5891f1d508e0': 's1',
  'f59635a9-bd8c-4328-bd69-9cb4639a93a9': 's2',
  '11047b03-e881-4ed7-b225-1f7727fa92d3': 's3',
  'aa8547fd-0bdb-427e-815a-0e3f6608154b': 's4',
  'db2c3f48-1747-4137-a442-563c692aad5e': 's5',
}
